import React, { useEffect, useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { adminService } from '../../api';
import './AdminReportsPage.css';

const REASON_LABELS = {
    0: 'Спам',
    1: 'Мошенничество',
    2: 'Неверная категория',
    3: 'Уже продано',
    4: 'Некорректная цена',
    5: 'Оскорбления',
    6: 'Другое',
};

const STATUS_LABELS = {
    0: 'Новая',
    1: 'Обработана',
    2: 'Отклонена',
};

const AdminReportsPage = () => {
    const [reports, setReports] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [busyId, setBusyId] = useState(null);
    const [statusFilter, setStatusFilter] = useState(0); // New by default

    const load = useCallback(() => {
        setLoading(true);
        setError(null);
        adminService.getReports(statusFilter)
            .then(({ data }) => setReports(data))
            .catch(() => setError('Не удалось загрузить жалобы.'))
            .finally(() => setLoading(false));
    }, [statusFilter]);

    useEffect(() => { load(); }, [load]);

    const resolve = async (id, action) => {
        setBusyId(id);
        try {
            await adminService.resolveReport(id, action);
            setReports(prev => prev.filter(r => r.id !== id));
        } catch {
            alert('Не удалось обработать жалобу.');
        } finally {
            setBusyId(null);
        }
    };

    return (
        <div className="admin-reports">
            <h1 className="admin-reports__title">Жалобы на объявления</h1>

            <div className="admin-reports__tabs">
                {Object.entries(STATUS_LABELS).map(([value, label]) => (
                    <button
                        key={value}
                        className={`admin-reports__tab ${Number(value) === statusFilter ? 'admin-reports__tab--active' : ''}`}
                        onClick={() => setStatusFilter(Number(value))}
                    >
                        {label}
                    </button>
                ))}
            </div>

            {loading && <div className="admin-reports__placeholder">Загрузка...</div>}
            {error && <div className="admin-reports__placeholder">{error}</div>}
            {!loading && !error && reports.length === 0 && (
                <div className="admin-reports__placeholder">Жалоб нет.</div>
            )}

            <div className="admin-reports__list">
                {reports.map(r => (
                    <div key={r.id} className="admin-reports__card">
                        <div className="admin-reports__card-main">
                            <Link to={`/ad/${r.adId}`} target="_blank" className="admin-reports__ad-title">
                                {r.adTitle || 'Объявление удалено'}
                            </Link>
                            <div className="admin-reports__meta">
                                Причина: <b>{REASON_LABELS[r.reason] ?? r.reason}</b> · от {r.reporterName || 'пользователя'}
                            </div>
                            {r.comment && <div className="admin-reports__comment">«{r.comment}»</div>}
                            <div className="admin-reports__date">{new Date(r.createdAt).toLocaleString('ru-RU')}</div>
                        </div>

                        {statusFilter === 0 && (
                            <div className="admin-reports__actions">
                                <button
                                    className="admin-reports__btn admin-reports__btn--block"
                                    disabled={busyId === r.id}
                                    onClick={() => resolve(r.id, 'block')}
                                >
                                    Заблокировать объявление
                                </button>
                                <button
                                    className="admin-reports__btn admin-reports__btn--dismiss"
                                    disabled={busyId === r.id}
                                    onClick={() => resolve(r.id, 'dismiss')}
                                >
                                    Отклонить жалобу
                                </button>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminReportsPage;
